export const removeBullet = (text: string) => {
  if (!text) {
    return text;
  }

  return text.replace(/•\s/g, '');
};
